export default (getOptionValue) => ({ form, field }) => (option) => {
  form.setFieldValue(field.name, option)
}
